/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import JobStatusIcon from '@ion/applications/src/pages/jobstatus/JobStatusIcon';
import {setJobStatus} from '@ion/applications/src/pages/jobstatus/state';
import {selectShowJobStatusDrawer} from '@ion/applications/src/pages/jobstatus/state-selectors';

/**
 * @JobStatusToggle
 *
 * Defines a component to display job status page toggle.
 *
 * ```typescript
 *   import JobStatusToggle from '@ion/packages/ion-ctc-admin/src/header/JobStatusToggle';
 *
 *   <JobStatusToggle />;
 *
 * ```
 */
const JobStatusToggle = () => {
  const dispatch        = useDispatch();
  const jobStatusOpen   = useSelector(selectShowJobStatusDrawer);
  const toggleJobStatus = useCallback(function() {
    dispatch(setJobStatus(!jobStatusOpen));
  }, [jobStatusOpen]);
  return (
    <JobStatusIcon onJobStatusClick={toggleJobStatus}/>
  );
};

export default JobStatusToggle;
